module.exports = __webpack_public_path__ + "img/7-1.de656905.png";